import styled from 'styled-components'
import { Color } from '../../theme'

export const BreadcrumbContainer = styled.ul`
  display: block;
  max-width: 910px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0;
  margin: 0;
  a {
    color: ${Color['grey-3']};
  }
  @media (max-width: 599px) {
    max-width: 85%;
    margin: 0 auto;
  }
  li {
    display: inline;
    font-size: 14px;
    margin: 0;
    * {
      display: inline;
    }
    &::after {
      content: ${(props) => `"${props.separator}"`};
      padding: 0 8px;
      color: ${Color['grey-9']};
    }
    &:last-child::after {
      content: '';
      color: ${Color['grey-9']};
      padding: 0;
    }
    &:last-child a {
      color: ${Color['theme-1']};
    }
    h2 {
      display: inline;
      font-size: 14px;
      font-weight: 300;
    }
  }
`
